import { CommonHttpOption } from "./../../base/common-http-option";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ExceptionalCoefficientsService {

  constructor(private core: CoreService) {}


  coefficientsList(filter:any,page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.exceptionalCoefficients.coefficientsList,
      new CommonHttpOption().headers,
     // new CommonHttpOption().paginator(page, pageSize)
      new CommonHttpOption().paginator(page, pageSize,"Id",true)
      .append('BranchCoefficientStart', filter && filter.BranchCoefficientStart ? filter.BranchCoefficientStart : '')
      .append('BranchEncryptId', filter && filter.BranchEncryptId ? filter.BranchEncryptId : '')
      .append('BranchCoefficientEnd', filter && filter.BranchCoefficientEnd ? filter.BranchCoefficientEnd : '')
      .append('CoursePatternId', filter && filter.CoursePatternId ? filter.CoursePatternId : '')
      .append('CoursePatternCoefficientStart', filter && filter.CoursePatternCoefficientStart ? filter.CoursePatternCoefficientStart : '')
      .append('CoursePatternCoefficientEnd', filter && filter.CoursePatternCoefficientEnd ? filter.CoursePatternCoefficientEnd : '')
      .append('PackageId', filter && filter.PackageId ? filter.PackageId : '')
      .append('LevelInfoId', filter && filter.LevelInfoId ? filter.LevelInfoId : '')
      .append('LevelInfoCoefficientStart', filter && filter.LevelInfoCoefficientStart ? filter.LevelInfoCoefficientStart : '')
      .append('LevelInfoCoefficientEnd', filter && filter.LevelInfoCoefficientEnd ? filter.LevelInfoCoefficientEnd : '')
      .append('TimeStart', filter && filter.TimeStart ? filter.TimeStart : '')
      .append('TimeEnd', filter && filter.TimeEnd ? filter.TimeEnd : '')
      .append('CoefficientStart', filter && filter.CoefficientStart ? filter.CoefficientStart : '')
      .append('CoefficientEnd', filter && filter.CoefficientEnd ? filter.CoefficientEnd : '')
      );
  }

  // service for create EC and coll Api coefficientsAdd
  coefficientsAdd(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.exceptionalCoefficients.coefficientsAdd,
      data,
      new CommonHttpOption().headers
    );
  }

  coefficientsEdit(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.exceptionalCoefficients.coefficientsEdit,
      data,
      new CommonHttpOption().headers
    );
  }

  setCoefficientAfterTime(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.exceptionalCoefficients.setCoefficientAfterTime,
      data,
      new CommonHttpOption().headers
    );
  }

  getCoefficient(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.exceptionalCoefficients.getCoefficient,
      data,
      new CommonHttpOption().headers
    );
  }

  coefficientsDelete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.exceptionalCoefficients.coefficientsDelete,
      new CommonHttpOption().headers,
      data
    );
  }

}
